export const stripEmptyTags = html => {
  html = html.replace(/<p>(&nbsp;)+<\/p>/i, '')
  return html
}

export const getSortedFormType = type => {
  switch (type) {
    case 'Registration Form':
    case 'membership':
    case 'Membership:':
      return 'membership'
    case 'Shop':
    case 'Shop Form':
    case 'shop':
    case 'Addon':
    case 'Add-On':
    case 'addon':
      return 'shop'
    case 'Event':
    case 'event':
      return 'event'
    default:
      return ''
  }
}
